export const isInteractiveSelectionTarget = (target) => {
  return !!target.closest(
    "button, input, select, textarea, label, .repo-action-dot, .dropdown-menu, .repo-card-actions, .repo-search-container, .repo-modal, .repo-modal-overlay, .repo-filter-dropdown-wrapper",
  );
};
